/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from "../vendors/jquery-magnificpopup";
import organicTabs from "../vendors/organic-tab";
import slick from "../vendors/slick.min";
import owlCarousel from "../vendors/owl.carousel.min";

jQuery(document).on("scroll", function () {
	if (jQuery(document).scrollTop() > 0) {
		jQuery("header, body").addClass("shrink");
	} else {
		jQuery("header, body").removeClass("shrink");
	}
});

jQuery(function () {
	/**
	 * Header Wrapper Height Calculation for Navigation Overlay
	 */

	if (jQuery(".header-wrapper").length > 0) {
		function updateHeaderHeight() {
			jQuery(".header-wrapper").each(function () {
				jQuery(this).css(
					"--slr_header-wrapper-default",
					jQuery(this).outerHeight() + "px",
				);
			});
		}
		updateHeaderHeight();
		jQuery(window).resize(updateHeaderHeight);
	}

	/**
	 * Toggle menu for mobile
	 */
	const navOverlay = jQuery(".nav-overlay");
	const htmlBody = jQuery("html, body");

	jQuery(".menu-btn").on("click", function () {
		jQuery(this).toggleClass("active");
		navOverlay.toggleClass("open");
		htmlBody.toggleClass("no-overflow");
		jQuery(".header-nav ul li.active").removeClass("active");
		jQuery(".header-nav ul.sub-menu").slideUp();
	});

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery(".menu-item-has-children > a:first-child").each(function () {
		jQuery(this).after('<span class="submenu-icon"></span>');
	});

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery(".header-nav").on("click", ".submenu-icon", function () {
		const parentLi = jQuery(this).closest("li");

		parentLi.siblings(".active").removeClass("active").find("ul").slideUp();

		parentLi
			.toggleClass("active")
			.find("ul")
			.stop(true, true)
			.slideToggle();
		parentLi
			.parents("ul")
			.toggleClass("disabled-menu", parentLi.hasClass("active"));
	});

	/**
	 *  Accessibility for Simple menu & Mega menu
	 */
	jQuery(".menu-item-has-children > a").on("focus blur", function (event) {
		jQuery(this)
			.siblings(".sub-menu, .mega-menu")
			.toggleClass("focused", event.type === "focus");
	});

	jQuery(".sub-menu a, .mega-menu a").on("focus blur", function (event) {
		jQuery(this)
			.closest(".sub-menu, .mega-menu")
			.toggleClass("focused", event.type === "focus");
	});

	/**
	 * Script for Accessibility of html Tags
	 */
	jQuery(
		"h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date",
	).each(function () {
		jQuery(this).attr({
			tabindex: 0,
		});
	});
	jQuery(".header-nav li, .blog-nav li, .footer-nav li, .legal-nav li").each(
		function () {
			const link = jQuery(this).find("a");
			if (link.length > 0) {
				jQuery(this).removeAttr("tabindex");
			} else {
				jQuery(this).attr("tabindex", "0");
			}
		},
	);
	jQuery("form p").each(function () {
		jQuery(this).removeAttr("tabindex");
	});

	jQuery("a,button:not([href])").each(function () {
		jQuery(this).attr({
			tabindex: 0,
		});
	});

	setTimeout(() => {
		jQuery("#daextlwcnf-cookie-notice-button-1").attr("role", "button");
		jQuery("#daextlwcnf-cookie-notice-button-2").attr("role", "button");
		jQuery("#daextlwcnf-cookie-settings-button-1").attr("role", "button");
		jQuery("#daextlwcnf-cookie-settings-button-2").attr("role", "button");
	}, 500);

	autosize();
	function autosize() {
		const text = jQuery("textarea");

		text.each(function () {
			jQuery(this).attr("rows", 5);
			resize(jQuery(this));
		});

		text.on("input", function () {
			resize(jQuery(this));
		});

		function resize($text) {
			$text.css("min-height", "auto");
			$text.css("min-height", $text[0].scrollHeight + "px");
		}
	}
});

// Redundant banner carousel initialization removed

jQuery(document).ready(function ($) {
	$(".sevice-carousel").owlCarousel({
		loop: false,
		margin: 47,
		nav: true,
		dots: false,
		autoplay: false,
		smartSpeed: 1000,
		autoplayTimeout: 3000,
		responsive: {
			0: {
				items: 1,
			},
			860: {
				items: 2,
			},
		},
	});
});

jQuery(document).ready(function ($) {
	$(".lasted-carousel").owlCarousel({
		loop: true,
		margin: 47,
		nav: true,
		dots: false,
		autoplay: false,
		smartSpeed: 1000,
		autoplayTimeout: 3000,
		responsive: {
			0: {
				items: 1,
			},
			860: {
				items: 1,
			},
		},
	});
});

jQuery(document).ready(function ($) {
	$(".testimonial-carousel").owlCarousel({
		loop: true,
		margin: 20,
		nav: true,
		dots: false,
		autoplay: false,
		smartSpeed: 1000,
		center: true,
		autoplayTimeout: 3000,
		responsive: {
			0: {
				items: 1,
			},
			747: {
				items: 2,
			},
			860: {
				items: 3,
			},
		},
	});
});

(function ($) {
	// ensures $ works in WP noConflict mode

	function openModal(modalId) {
		var $modal = $("#" + modalId);
		var $content = $modal.find(".modal-contents");

		$modal.css({
			display: "block",
			overflowY: "auto",
		});

		var viewportHeight = $(window).height();
		var viewportWidth = $(window).width();
		var contentHeight = $content.outerHeight();
		var contentWidth = $content.outerWidth();

		var topPosition =
			contentHeight < viewportHeight
				? (viewportHeight - contentHeight) / 2
				: 20;
		var leftPosition = (viewportWidth - contentWidth) / 2;

		$content.css({
			position: "absolute",
			top: "0px",
			left: leftPosition + "px",
			opacity: 0,
			maxHeight: "90vh",
			overflowY: "auto",
		});

		setTimeout(function () {
			$content.css({
				transition: "top 0.5s, opacity 0.5s",
				top: topPosition + "px",
				opacity: 1,
			});
		}, 10);
	}

	function closeModal(modalId) {
		var $modal = $("#" + modalId);
		var $content = $modal.find(".modal-contents");

		$content.css({
			transition: "top 0.5s, opacity 0.5s",
			opacity: 0,
			top: "0px",
		});

		setTimeout(function () {
			$modal.css("display", "none");
		}, 500);
	}

	function stopIframeVideo($modal) {
		$modal.find("iframe").each(function () {
			var $iframe = $(this);
			var src = $iframe.attr("src");
			$iframe.attr("src", "");
			setTimeout(function () {
				$iframe.attr("src", src);
			}, 500);
		});
	}

	// Use event delegation for dynamic content
	$(document).on("click", "a[href^='#']", function (event) {
		event.preventDefault();
		var modalId = $(this).attr("href").substring(1);
		openModal(modalId);
	});

	$(document).on("click", ".close-btns", function (e) {
		e.stopPropagation();
		var $modal = $(this).closest(".styles-modal");
		var modalId = $modal.attr("id");
		stopIframeVideo($modal);
		closeModal(modalId);
	});

	// Close when clicking outside modal content
	$(document).on("click", ".styles-modal", function (event) {
		if ($(event.target).is(this)) {
			var $modal = $(this);
			stopIframeVideo($modal);
			closeModal($modal.attr("id"));
		}
	});
})(jQuery);

// project  slider

function initSvgSlider($container) {
	var duration = 500,
		epsilon = 1000 / 60 / duration / 4;

	function bezier(x1, y1, x2, y2, epsilon) {
		var curveX = function (t) {
			var v = 1 - t;
			return 3 * v * v * t * x1 + 3 * v * t * t * x2 + t * t * t;
		};
		var curveY = function (t) {
			var v = 1 - t;
			return 3 * v * v * t * y1 + 3 * v * t * t * y2 + t * t * t;
		};
		var derivativeCurveX = function (t) {
			var v = 1 - t;
			return (
				3 * (2 * (t - 1) * t + v * v) * x1 +
				3 * (-t * t * t + 2 * v * t) * x2
			);
		};
		return function (t) {
			var x = t,
				t0,
				t1,
				t2,
				x2,
				d2,
				i;
			for (t2 = x, i = 0; i < 8; i++) {
				x2 = curveX(t2) - x;
				if (Math.abs(x2) < epsilon) return curveY(t2);
				d2 = derivativeCurveX(t2);
				if (Math.abs(d2) < 1e-6) break;
				t2 = t2 - x2 / d2;
			}
			(t0 = 0), (t1 = 1), (t2 = x);
			if (t2 < t0) return curveY(t0);
			if (t2 > t1) return curveY(t1);
			while (t0 < t1) {
				x2 = curveX(t2);
				if (Math.abs(x2 - x) < epsilon) return curveY(t2);
				if (x > x2) t0 = t2;
				else t1 = t2;
				t2 = (t1 - t0) * 0.5 + t0;
			}
			return curveY(t2);
		};
	}

	var customMinaIn = bezier(0.42, 0.03, 0.77, 0.63, epsilon),
		customMinaOut = bezier(0.27, 0.5, 0.6, 0.99, epsilon);

	var sliding = false;
	var $slider = $container.find(".slider");
	var $controls = $container.find(".slider-controls");
	var $heading = $container.find(".lastest-head");
	var $counter = $container.find(".slider-counter");

	if ($counter.length) {
		$counter.find("#total").text($slider.find("li").length);
	}

	var initTimeline = new TimelineMax();
	if ($heading.length) {
		initTimeline
			.to($heading.find(".text__first-bg"), 0.6, {
				scaleX: 1,
				ease: Power2.easeInOut,
			})
			.to($heading.find(".text__word"), 0.01, { opacity: 1 })
			.to($heading.find(".text__first-bg"), 0.6, {
				scaleX: 0,
				transformOrigin: "100% 50%",
				ease: Power2.easeInOut,
			});
	}

	initTimeline
		.set($container.find(".visible .slider__info > span"), {
			opacity: 1,
			delay: 0.2,
		})
		.to($container.find(".visible .text__first-bg"), 0.6, {
			scaleX: 1,
			ease: Power2.easeInOut,
		})
		.to(
			$container.find(".visible .text__second-bg"),
			0.6,
			{ scaleX: 1, ease: Power2.easeInOut },
			"-=0.4",
		)
		.to($container.find(".visible .text__word"), 0.01, { opacity: 1 })
		.to($container.find(".visible .button"), 0.3, { opacity: 1 }, "-=0.1")
		.to($container.find(".visible .text__first-bg"), 0.6, {
			scaleX: 0,
			transformOrigin: "100% 50%",
			ease: Power2.easeInOut,
		})
		.to(
			$container.find(".visible .text__second-bg"),
			0.6,
			{ scaleX: 0, transformOrigin: "100% 50%", ease: Power2.easeInOut },
			"-=0.4",
		);

	$controls.on("click", "a", function (event) {
		event.preventDefault();
		if (sliding) return false;
		sliding = true;
		var selectedItem = jQuery(this).parent("li"),
			selectedPosition = selectedItem.index(),
			activePosition = $controls.find("li.selected").index();
		if (activePosition == selectedPosition) {
			sliding = false;
			return false;
		}

		if ($counter.length) {
			$counter.find("#current").text(selectedPosition + 1);
		}

		var direction = activePosition < selectedPosition ? "next" : "prev",
			newSlide = $slider.find("li").eq(selectedPosition),
			currentSlide = $slider.find("li.visible"),
			svg = newSlide.find(".svg-wrapper path"),
			pathId = svg.attr("id"),
			svgPath = Snap("#" + pathId);

		$controls
			.find("li")
			.removeClass("selected")
			.eq(selectedPosition)
			.addClass("selected");
		newSlide.addClass("is-animating");
		TweenMax.set(newSlide.find(".text__word, .button"), { opacity: 0 });
		TweenMax.set(newSlide.find(".text__first-bg, .text__second-bg"), {
			scaleX: 0,
			transformOrigin: "0% 50%",
		});
		TweenMax.set(newSlide.find(".slider__info > span"), { opacity: 0 });
		var zoomOut = new TimelineMax();
		zoomOut
			.to($slider, 0.6, { scale: 0.9, ease: Power2.easeOut })
			.to(
				currentSlide.find(".text__word, .button"),
				0.3,
				{ opacity: 0 },
				0,
			)
			.to(currentSlide.find("image"), 0.6, { opacity: 0 }, 0);

		var stepData =
			direction == "next"
				? [
						$slider.data("step1"),
						$slider.data("step2"),
						$slider.data("step3"),
				  ]
				: [
						$slider.data("step4"),
						$slider.data("step5"),
						$slider.data("step6"),
				  ];

		svgPath.attr({ d: stepData[0] });
		svgPath.animate(
			{ d: stepData[1] },
			duration,
			customMinaIn,
			function () {
				svgPath.animate(
					{ d: stepData[2] },
					duration,
					customMinaOut,
					function () {
						currentSlide.removeClass("visible");
						newSlide
							.removeClass("is-animating")
							.addClass("visible");
						var zoomIn = new TimelineMax({
							onComplete: function () {
								TweenMax.set(currentSlide.find("image"), {
									opacity: 1,
								});
								sliding = false;
							},
						});
						zoomIn.to($slider, 1.2, {
							scale: 1,
							ease: Elastic.easeOut.config(1, 0.3),
						});

						if ($heading.length) {
							zoomIn
								.to(
									$heading.find(".text__first-bg"),
									0.6,
									{ scaleX: 1, ease: Power2.easeInOut },
									0.2,
								)
								.to(
									$heading.find(".text__word"),
									0.01,
									{ opacity: 1 },
									0.6,
								)
								.to(
									$heading.find(".text__first-bg"),
									0.6,
									{
										scaleX: 0,
										transformOrigin: "100% 50%",
										ease: Power2.easeInOut,
									},
									0.7,
								);
						}

						zoomIn
							.set(
								newSlide.find(".slider__info > span"),
								{ opacity: 1 },
								0.4,
							)
							.to(
								newSlide.find(".text__first-bg"),
								0.6,
								{ scaleX: 1, ease: Power2.easeInOut },
								0.5,
							)
							.to(
								newSlide.find(".text__second-bg"),
								0.6,
								{ scaleX: 1, ease: Power2.easeInOut },
								0.7,
							)
							.to(
								newSlide.find(".text__word"),
								0.01,
								{ opacity: 1 },
								1.0,
							)
							.to(
								newSlide.find(".button"),
								0.3,
								{ opacity: 1 },
								1.0,
							)
							.to(
								newSlide.find(".text__first-bg"),
								0.6,
								{
									scaleX: 0,
									transformOrigin: "100% 50%",
									ease: Power2.easeInOut,
								},
								1.1,
							)
							.to(
								newSlide.find(".text__second-bg"),
								0.6,
								{
									scaleX: 0,
									transformOrigin: "100% 50%",
									ease: Power2.easeInOut,
								},
								1.3,
							);
					},
				);
			},
		);
	});

	$slider
		.find("li")
		.on("transitionend webkitTransitionEnd oTransitionEnd", function () {
			if (!jQuery(this).hasClass("visible")) {
				TweenMax.set(jQuery(this).find("image"), {
					opacity: 1,
					scale: 1,
				});
				TweenMax.set(jQuery(this).find(".text__word, .button"), {
					opacity: 0,
				});
			}
		});

	$container.find(".btn-next").on("click", function (e) {
		e.preventDefault();
		if (sliding) return;
		var selected = $controls.find("li.selected"),
			next = selected.next("li");
		if (next.length > 0) next.find("a").trigger("click");
		else $controls.find("li").first().find("a").trigger("click");
	});

	$container.find(".btn-prev").on("click", function (e) {
		e.preventDefault();
		if (sliding) return;
		var selected = $controls.find("li.selected"),
			prev = selected.prev("li");
		if (prev.length > 0) prev.find("a").trigger("click");
		else $controls.find("li").last().find("a").trigger("click");
	});

	$container.swipe({
		swipeLeft: function () {
			var selected = $controls.find("li.selected"),
				next = selected.next("li");
			if (next.length > 0) next.find("a").trigger("click");
		},
		swipeRight: function () {
			var selected = $controls.find("li.selected"),
				prev = selected.prev("li");
			if (prev.length > 0) prev.find("a").trigger("click");
		},
		threshold: 50,
	});
}

jQuery(document).ready(function ($) {
	$(".lastest-projects, .banner-svg-slider").each(function () {
		initSvgSlider($(this));
	});
});

// select option
jQuery(document).ready(function ($) {
	// Dropdown toggle
	$(document).on("click", ".dropdown-trigger", function (e) {
		e.stopPropagation();
		$(this).closest(".filter-select").toggleClass("active");
	});

	// Option select
	$(document).on("click", ".dropdown-list a", function (e) {
		e.preventDefault();

		var selectedText = $(this).text();
		var selectedValue = $(this).data("value");

		var dropdown = $(this).closest(".filter-select");

		// Update trigger text
		dropdown.find(".dropdown-trigger").text(selectedText);

		// Close dropdown
		dropdown.removeClass("active");

		// URL handling
		var currentUrl = new URL(window.location.href);

		// Reset pagination
		currentUrl.searchParams.set("paged", 1);

		if (selectedValue === "all" || selectedValue === "all types") {
			currentUrl.searchParams.delete("type");
		} else {
			currentUrl.searchParams.set("type", selectedValue);
		}

		window.location.href = currentUrl.toString();
	});

	// Click outside to close
	$(document).on("click", function () {
		$(".filter-select").removeClass("active");
	});
});
